const YouTube = () => (
    <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11 3C1.17143 3 1 3.90182 1 11C1 18.0982 1.17143 19 11 19C20.8286 19 21 18.0982 21 11C21 3.90182 20.8286 3 11 3ZM14.2 11.3491L9.71429 13.5309C9.31429 13.72 9 13.5018 9 13.0509V8.94909C9 8.49818 9.32857 8.28 9.71429 8.46909L14.2 10.6509C14.6 10.84 14.6 11.16 14.2 11.3491Z"
            fill="white"
        />
    </svg>
);

export default YouTube;
